import { CheckboxActiveIcon } from "app/components/Icons";
import CheckboxIcon from "app/components/Icons/CheckboxIcon";
import clsx from "clsx";
import React from "react";
import ContentJson from "app/containers/Features/containers/Sprints/ContentJson.json";

interface Props {
  isChecked: boolean;
  onChecked: () => void;
}
const RetrospectiveCheckedArea: React.FC<Props> = ({
  isChecked,
  onChecked,
}) => {
  const { retrospectiveRequest } = ContentJson.retrospective;
  return (
    <div className=" flex ">
      <button
        className={clsx(
          "flex gap-4 items-center  text-start rounded w-fir h-[42px] px-4 border",
          isChecked
            ? "  border-[#5A8DF133] bg-[#5A8DF11A] "
            : "  border-gray-200 bg-white"
        )}
        onClick={onChecked}
      >
        {isChecked ? (
          <CheckboxActiveIcon size={28} />
        ) : (
          <CheckboxIcon size={27} />
        )}
        <span className=" text-[#333E4D] text-xs font-normal ">
          {retrospectiveRequest}
        </span>
      </button>
    </div>
  );
};

export default RetrospectiveCheckedArea;
